export interface ChickenBreed {
  id: string
  name: string
  type: string
  description: string
  image: string
  images: string[]
  videoUrl?: string
  characteristics: {
    berat: string
    produksiTelur?: string
    warnaTelur?: string
    temperamen: string
  }
  keunggulan: string[]
  kekurangan: string[]
  tips: string[]
  pakanHarian: string
  hargaDOC: string
}

export const chickenBreeds: ChickenBreed[] = [
  {
    id: "rhode-island-red",
    name: "Rhode Island Red",
    type: "Petelur",
    description:
      "Rhode Island Red adalah salah satu ras ayam petelur paling populer di dunia. Ayam ini berasal dari Amerika Serikat dan dikenal dengan produktivitas telur yang tinggi serta daya tahan tubuh yang baik. Cocok untuk peternak pemula maupun berpengalaman.",
    image: "/images/chicken/RIR/RIR-1.png",
    images: ["/images/chicken/RIR/RIR-1.png", "/images/chicken/RIR/RIR-2.png", "/images/chicken/RIR/RIR-3.png", "/images/chicken/RIR/RIR-4.png"],
    // videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    characteristics: {
      berat: "Jantan: 3.5-4.0 kg, Betina: 2.5-3.0 kg",
      produksiTelur: "250-300 butir/tahun",
      warnaTelur: "Coklat medium",
      temperamen: "Tenang, jinak, mudah dirawat",
    },
    keunggulan: [
      "Produksi telur tinggi dan stabil",
      "bisa untuk materi pigmen telur warna coklat",
      "Temperamen tenang dan jinak",
      "Pertumbuhan cepat dan efisien",
    ],
    kekurangan: [
      "Jika sirkulasi kandang kurang baik, ayam sering kena SNOT",
      "Kurang cocok untuk pedaging",
      "Tidak mengerami telurnya",
    ],
    tips: [
      "Berikan pakan layer dengan protein 16-18%",
      "Pastikan ketersediaan air bersih 24 jam",
      "Berikan cahaya tambahan 14-16 jam/hari untuk produksi optimal",
      "Lakukan vaksinasi lengkap sesuai jadwal",
      "Jaga kebersihan kandang dan ventilasi yang baik",
    ],
    pakanHarian: "120-130 gram/ekor/hari",
    hargaDOC: "Rp 40.000/ekor",
  },
  {
    id: "australorp",
    name: "Australorp",
    type: "Dwiguna",
    description:
      "Ayam Australorp merupakan pendatang baru di dunia peternakan ayam yang berasal dari Australia. Nama tersebut merupakan singkatan dari Australian Black Orpington. Pada awal tahun 1900-an, ayam Orpington milik William Cook diimpor ke Australia dan disilangkan dengan Rhode Island Red, Minorca, White Leghorn, Langshan, dan Plymouth Rock untuk menciptakan unggas dwiguna yang cocok untuk iklim Australia. Hasilnya adalah seekor unggas petelur fenomenal dengan rekor dunia 364 butir telur dalam 365 hari tanpa penerangan tambahan. Australorp dinobatkan sebagai burung nasional kehormatan Australia. Bulu hitamnya memiliki kilau hijau seperti kumbang di bawah sinar matahari. Meskipun awalnya pemalu, ayam ini dikenal sangat ramah dan cocok untuk pemula.",
    image: "/images/chicken/Australorp/as-1.png",
    images: ["/images/chicken/Australorp/as-1.png", "/images/chicken/Australorp/as-2.png", "/images/chicken/Australorp/as-3.png", "/images/chicken/Australorp/as-4.png"],
    characteristics: {
      berat: "Jantan: 3.9-4.5 kg, Betina: 3.0-3.6 kg. Bantam Jantan: 0.9-1.2 kg, Bantam Betina: 0.8-1.0 kg",
      produksiTelur: "250-300 butir/tahun (rata-rata 5 butir/minggu)",
      warnaTelur: "Coklat muda berukuran sedang",
      temperamen: "Tenang, pendiam, awalnya pemalu tapi menjadi ramah setelah terbiasa",
    },
    keunggulan: [
      "Produksi telur sangat tinggi (rekor dunia 364 butir/tahun)",
      "Dwiguna - cocok untuk telur dan daging berkualitas",
      "Sangat jinak dan ramah, cocok untuk anak-anak dan pemula",
      "Tahan terhadap berbagai suhu dan cuaca (panas maupun dingin)",
      "Bisa dipelihara di kandang kecil maupun free range",
      "Induk yang baik dan bisa mengerami telurnya",
      "Ras warisan yang kuat dan sehat dengan umur 6-10 tahun",
      "Bulu hitam indah dengan kilau hijau seperti kumbang",
    ],
    kekurangan: [
      "Pertumbuhan agak lambat",
      "Lebih rentan terhadap serangan panas karena bulu hitam",
      "Cenderung obesitas jika hanya dikurung tanpa aktivitas",
      "Bisa diintimidasi oleh ras ayam yang lebih agresif",
      "Kurang waspada terhadap predator",
    ],
    tips: [
      "Sediakan tempat teduh sepanjang waktu karena bulu hitam menyerap panas",
      "Berikan pakan layer berkualitas tinggi dengan kontrol porsi untuk mencegah obesitas",
      "Biarkan free range untuk mencari serangga dan menjaga berat badan ideal",
      "Sediakan tempat bertelur yang nyaman dan gelap",
      "Awasi jika dipelihara bersama ras yang lebih agresif",
      "Berikan vitamin tambahan saat musim pancaroba",
      "Lakukan perawatan rutin terhadap parasit",
      "Cocok untuk program pertanian 4H dan pameran ayam",
    ],
    pakanHarian: "115-125 gram/ekor/hari",
    hargaDOC: "Rp 18.000 - Rp 25.000/ekor",
  },
  {
    id: "plymouth-barred-rock",
    name: "Plymouth Barred Rock",
    type: "Dwiguna",
    description:
      "Plymouth Rock adalah ayam dwiguna (dual purpose) yang sangat populer di Amerika. Ayam ini memiliki bulu belang hitam putih yang khas dan bisa dimanfaatkan untuk produksi telur maupun daging.",
    image: "/images/chicken/BarredRock/BR-1.png",
    images: ["/images/chicken/BarredRock/BR-1.png", "/images/chicken/BarredRock/BR-2.png"],
    characteristics: {
      berat: "Jantan: 4.0-5.0 kg, Betina: 3.0-3.5 kg",
      produksiTelur: "200-250 butir/tahun",
      warnaTelur: "Coklat muda",
      temperamen: "Sangat jinak, cocok untuk keluarga",
    },
    keunggulan: [
      "Bisa untuk telur dan daging",
      "Sangat jinak dan mudah dipelihara",
      "Cocok untuk backyard farming",
      "Induk yang baik (suka mengerami)",
      "Tahan cuaca ekstrem",
    ],
    kekurangan: [
      "Produksi telur tidak setinggi layer murni",
      "Pertumbuhan lebih lambat dari broiler",
      "Konsumsi pakan cukup banyak",
    ],
    tips: [
      "Berikan pakan all purpose 18-20% protein",
      "Sediakan ruang yang cukup untuk bergerak",
      "Biarkan ayam mencari makan alami (free range)",
      "Pisahkan induk yang mengerami",
      "Berikan suplemen kalsium untuk kualitas telur",
    ],
    pakanHarian: "130-150 gram/ekor/hari",
    hargaDOC: "Rp 20.000 - Rp 30.000/ekor",
  },
  {
    id: "silver-penciled-rock",
    name: "Silver Penciled Rock",
    type: "Petelur",
    description:
      "Silver Penciled Rock adalah varian dari Plymouth Rock dengan bulu berwarna silver yang indah. Ayam ini memiliki pola bulu yang unik dan menjadi favorit untuk peternakan backyard.",
    image: "/images/chicken/PenciledRock/PR-1.png",
    images: ["/images/chicken/PenciledRock/PR-1.png", "/images/chicken/PenciledRock/PR-2.png", "/images/chicken/PenciledRock/PR-3.png", "/images/chicken/PenciledRock/PR-4.png"],
    characteristics: {
      berat: "Jantan: 3.5-4.0 kg, Betina: 2.5-3.0 kg",
      produksiTelur: "180-220 butir/tahun",
      warnaTelur: "Coklat muda",
      temperamen: "Tenang dan ramah",
    },
    keunggulan: [
      "Penampilan sangat menarik",
      "Cocok untuk ornamental dan produksi",
      "Jinak dan mudah dirawat",
      "Tahan penyakit",
      "Induk yang baik",
    ],
    kekurangan: [
      "Produksi telur sedang",
      "Harga bibit lebih mahal",
      "Tidak umum di Indonesia",
    ],
    tips: [
      "Rawat kebersihan bulu dengan baik",
      "Berikan pakan berkualitas untuk warna bulu optimal",
      "Lindungi dari predator",
      "Sediakan tempat berteduh yang nyaman",
      "Vaksinasi lengkap",
    ],
    pakanHarian: "120-130 gram/ekor/hari",
    hargaDOC: "Rp 50.000/ekor",
  },
  {
    id: "merawang",
    name: "Ayam Merawang",
    type: "Pedaging",
    description:
      "Ayam Merawang adalah ayam lokal Indonesia yang berasal dari daerah Bangka Belitung. Ayam ini dikenal dengan pertumbuhan yang cepat dan daging yang berkualitas tinggi dengan rasa khas.",
    image: "/images/chicken/merawang/merawang-1.png",
    images: ["/images/chicken/merawang/merawang-1.png", "/images/chicken/merawang/merawang-2.png", "/images/chicken/merawang/merawang-3.png"],
    characteristics: {
      berat: "Jantan: 2.5-3.5 kg, Betina: 2.0-2.5 kg",
      temperamen: "Aktif dan lincah",
    },
    keunggulan: [
      "Daging berkualitas tinggi dengan rasa khas",
      "Pertumbuhan relatif cepat untuk ayam lokal",
      "Tahan terhadap penyakit lokal",
      "Harga jual tinggi di pasaran",
      "Mudah beradaptasi dengan lingkungan Indonesia",
    ],
    kekurangan: [
      "Bibit sulit didapat",
      "Harga DOC relatif mahal",
      "Memerlukan area yang luas",
    ],
    tips: [
      "Berikan pakan dengan protein 20-22%",
      "Sediakan area umbaran yang cukup",
      "Jaga kebersihan kandang",
      "Berikan vaksin ND dan Gumboro",
      "Panen pada umur 3-4 bulan",
    ],
    pakanHarian: "100-120 gram/ekor/hari",
    hargaDOC: "Rp 30.000/ekor",
  },
  {
    id: "elba",
    name: "Ayam ELBA",
    type: "Petelur",
    description:
      "ELBA (Elite Layer Balitnak) adalah ayam petelur unggul hasil pengembangan Balitnak (Balai Penelitian Ternak) Indonesia. Ayam ini dikenal dengan produktivitas telur yang tinggi dan adaptasi yang baik terhadap kondisi tropis Indonesia. ELBA dikembangkan untuk memenuhi kebutuhan peternak lokal akan bibit unggul yang terjangkau.",
    image: "/images/chicken/Elba/elba-1.png",
    images: ["/images/chicken/Elba/elba-1.png", "/images/chicken/Elba/elba-2.png", "/images/chicken/Elba/elba-3.png", "/images/chicken/Elba/elba-4.png"],
    characteristics: {
      berat: "Jantan: 2.5-3.0 kg, Betina: 1.8-2.2 kg",
      produksiTelur: "250-280 butir/tahun",
      warnaTelur: "Coklat",
      temperamen: "Tenang dan mudah beradaptasi",
    },
    keunggulan: [
      "Hasil pengembangan lokal, cocok untuk iklim Indonesia",
      "Produksi telur tinggi dan konsisten",
      "Tahan terhadap penyakit tropis",
      "Konsumsi pakan efisien",
      "Harga DOC lebih terjangkau dibanding impor",
      "Didukung oleh Balitnak untuk pengembangan",
    ],
    kekurangan: [
      "Ketersediaan DOC masih terbatas di beberapa daerah",
      "Perlu manajemen yang baik untuk performa optimal",
      "Ukuran telur sedikit lebih kecil dari strain impor",
    ],
    tips: [
      "Berikan pakan layer dengan protein 16-17%",
      "Pastikan vaksinasi lengkap sesuai program",
      "Jaga suhu kandang optimal 20-28°C",
      "Berikan pencahayaan 16 jam/hari saat produksi",
      "Hubungi Balitnak atau dinas peternakan untuk mendapatkan DOC",
    ],
    pakanHarian: "100-115 gram/ekor/hari",
    hargaDOC: "Rp 12.000 - Rp 18.000/ekor",
  },
  {
    id: "kuntara",
    name: "Ayam KUNTARA",
    type: "Pedaging",
    description:
      "KUNTARA adalah ayam pedaging lokal hasil persilangan yang dikembangkan untuk menghasilkan daging berkualitas dengan cita rasa khas ayam kampung. Nama KUNTARA berasal dari singkatan Kampung Unggul Balitnak Ciawi. Ayam ini menjadi solusi bagi peternak yang ingin memelihara ayam dengan rasa daging premium namun dengan pertumbuhan yang lebih cepat dari ayam kampung biasa.",
    image: "/images/chicken/kuntara/kuntara-1.png",
    images: ["/images/chicken/kuntara/kuntara-1.png", "/images/chicken/kuntara/kuntara-2.png", "/images/chicken/kuntara/kuntara-3.png", "/images/chicken/kuntara/kuntara-4.png"],
    characteristics: {
      berat: "Jantan: 2.0-2.5 kg (10 minggu), Betina: 1.5-2.0 kg",
      temperamen: "Aktif, cocok untuk sistem umbaran",
    },
    keunggulan: [
      "Rasa daging mirip ayam kampung",
      "Pertumbuhan lebih cepat dari ayam kampung murni",
      "Tekstur daging kenyal dan tidak lembek",
      "Cocok untuk pasar ayam kampung premium",
      "Harga jual lebih tinggi dari broiler",
      "Tahan terhadap penyakit lokal",
    ],
    kekurangan: [
      "Pertumbuhan lebih lambat dari broiler modern",
      "FCR lebih tinggi dibanding broiler",
      "Memerlukan sistem pemeliharaan semi-intensif",
      "Ketersediaan DOC masih terbatas",
    ],
    tips: [
      "Berikan pakan dengan protein 18-20%",
      "Sediakan area umbaran untuk aktivitas",
      "Panen optimal di umur 10-12 minggu",
      "Kombinasikan pakan komersial dengan pakan tambahan lokal",
      "Jaga kepadatan kandang tidak terlalu tinggi",
    ],
    pakanHarian: "80-100 gram/ekor/hari",
    hargaDOC: "Rp 8.000 - Rp 12.000/ekor",
  },
  {
    id: "leghorn",
    name: "Leghorn",
    type: "Petelur",
    description:
      "Leghorn adalah ras ayam petelur yang berasal dari Italia dan terkenal di seluruh dunia sebagai ayam petelur paling efisien. Ayam ini memiliki tubuh ramping dengan jengger besar dan menghasilkan telur putih dalam jumlah sangat banyak. Leghorn menjadi dasar genetik bagi banyak strain layer komersial modern.",
    image: "/images/chicken/Leghorn/leghorn-1.png",
    images: ["/images/chicken/Leghorn/leghorn-1.png", "/images/chicken/Leghorn/leghorn-2.png", "/images/chicken/Leghorn/leghorn-3.png", "/images/chicken/Leghorn/leghorn-4.png"],
    characteristics: {
      berat: "Jantan: 2.5-3.0 kg, Betina: 1.8-2.2 kg",
      produksiTelur: "280-320 butir/tahun",
      warnaTelur: "Putih",
      temperamen: "Aktif, gesit, agak nervous",
    },
    keunggulan: [
      "Produksi telur sangat tinggi (tertinggi di antara semua ras)",
      "Efisiensi pakan terbaik untuk layer",
      "Mulai bertelur lebih awal (umur 18-20 minggu)",
      "Masa produksi panjang",
      "Tubuh kecil sehingga hemat ruang",
      "Tahan panas",
    ],
    kekurangan: [
      "Temperamen nervous dan mudah stres",
      "Tidak cocok untuk dipelihara dengan sistem umbaran",
      "Kurang jinak dibanding ras lain",
      "Tidak cocok untuk produksi daging",
      "Telur putih kurang diminati di beberapa pasar Indonesia",
    ],
    tips: [
      "Pelihara di kandang battery atau closed house",
      "Hindari suara keras dan gangguan mendadak",
      "Berikan pakan layer protein 16-18%",
      "Jaga pencahayaan stabil 16 jam/hari",
      "Lakukan handling dengan hati-hati",
      "Cocok untuk farm skala besar dengan sistem modern",
    ],
    pakanHarian: "95-110 gram/ekor/hari",
    hargaDOC: "Rp 10.000 - Rp 15.000/ekor",
  },
  {
    id: "sussex",
    name: "Sussex",
    type: "Dwiguna",
    description:
      "Sussex adalah ras ayam dwiguna yang berasal dari Inggris, tepatnya dari wilayah Sussex. Ayam ini sangat populer karena kombinasi produksi telur yang baik dan kualitas daging yang excellent. Varian Light Sussex dengan bulu putih dan leher hitam adalah yang paling terkenal. Sussex dikenal sebagai ayam yang sangat jinak dan cocok untuk pemula.",
    image: "/images/chicken/Sussex/sussex-1.png",
    images: ["/images/chicken/Sussex/sussex-1.png", "/images/chicken/Sussex/sussex-2.png", "/images/chicken/Sussex/sussex-3.png", "/images/chicken/Sussex/sussex-4.png"],
    characteristics: {
      berat: "Jantan: 4.0-4.5 kg, Betina: 3.0-3.5 kg",
      produksiTelur: "200-250 butir/tahun",
      warnaTelur: "Coklat muda hingga krem",
      temperamen: "Sangat jinak, ramah, mudah ditangani",
    },
    keunggulan: [
      "Dwiguna - bagus untuk telur dan daging",
      "Temperamen sangat jinak dan ramah",
      "Cocok untuk keluarga dengan anak-anak",
      "Tahan terhadap berbagai kondisi cuaca",
      "Induk yang baik dan bisa mengerami",
      "Daging berkualitas tinggi dengan rasa lezat",
      "Mudah beradaptasi dengan berbagai sistem pemeliharaan",
      "Penampilan cantik dengan bulu kontras",
    ],
    kekurangan: [
      "Pertumbuhan tidak secepat broiler modern",
      "Produksi telur tidak setinggi layer komersial",
      "Konsumsi pakan relatif banyak karena ukuran besar",
      "Kurang waspada terhadap predator",
    ],
    tips: [
      "Berikan pakan all purpose dengan protein 18-20%",
      "Sediakan ruang yang cukup untuk bergerak",
      "Cocok untuk sistem free range maupun kandang",
      "Berikan suplemen kalsium untuk kualitas telur",
      "Lindungi dari predator karena kurang waspada",
      "Bisa dijadikan induk untuk menetaskan telur ras lain",
    ],
    pakanHarian: "130-150 gram/ekor/hari",
    hargaDOC: "Rp 25.000 - Rp 40.000/ekor",
  },
  {
    id: "sasso",
    name: "Sasso",
    type: "Pedaging",
    description:
      "Sasso adalah strain ayam pedaging berwarna yang berasal dari Prancis, dikembangkan oleh perusahaan Sasso (Selection Avicole de la Sarthe et du Sud-Ouest). Ayam ini populer di Indonesia sebagai alternatif broiler dengan rasa daging yang lebih mirip ayam kampung. Sasso memiliki pertumbuhan yang baik dengan tekstur daging yang lebih kenyal dibanding broiler putih.",
    image: "/images/chicken/Sasso/sasso-1.png",
    images: ["/images/chicken/Sasso/sasso-1.png", "/images/chicken/Sasso/sasso-2.png", "/images/chicken/Sasso/sasso-3.png", "/images/chicken/Sasso/sasso-4.png"],
    characteristics: {
      berat: "Jantan: 2.5-3.5 kg (8-10 minggu), Betina: 2.0-2.5 kg",
      temperamen: "Aktif, cocok untuk sistem semi-intensif",
    },
    keunggulan: [
      "Rasa daging lebih gurih mirip ayam kampung",
      "Tekstur daging kenyal, tidak lembek",
      "Pertumbuhan lebih cepat dari ayam kampung",
      "Bulu berwarna sehingga diminati pasar",
      "Harga jual lebih tinggi dari broiler putih",
      "FCR lebih baik dari ayam kampung",
      "Cocok untuk pasar ayam kampung premium",
      "Tahan terhadap penyakit lebih baik dari broiler",
    ],
    kekurangan: [
      "Pertumbuhan lebih lambat dari broiler putih",
      "FCR lebih tinggi dari broiler modern",
      "Memerlukan sistem pemeliharaan semi-intensif",
      "Harga DOC lebih mahal dari broiler biasa",
    ],
    tips: [
      "Berikan pakan broiler dengan protein 20-22%",
      "Sediakan area untuk bergerak (tidak terlalu padat)",
      "Panen optimal di umur 8-10 minggu",
      "Bisa dikombinasikan dengan pakan tambahan lokal",
      "Jaga suhu brooding sama seperti broiler",
      "Cocok untuk sistem kandang litter atau panggung",
    ],
    pakanHarian: "100-130 gram/ekor/hari",
    hargaDOC: "Rp 8.000 - Rp 12.000/ekor",
  },
]
